// The tile text a quick-button scenario pick fills in: the picked scenario's
// name, or a count for several. Only while the text is empty or still holds
// the previous fill-in (`filled`) — typed or saved text is the user's and
// stays. null leaves the text as it is.
export const textForScenarioPick = (text, filled, picked, t) => {
  if ((text || "").trim() && text !== filled) return null;
  if (picked.size === 1) return picked.get(0).name;
  if (picked.size > 1) return t("scenarios.count", { count: picked.size });
  return null;
};
